module.exports = __webpack_public_path__ + "img/big_eye_redchart03.da7789b2.jpg";